import { gql } from '@apollo/client/core';
import { DEFAULT_SET_FIELDS } from '../DefaultSet/fragments';

export const VENUE_FIELDS = gql`
  fragment VenueFields on Venue {
    id
    name
    replyTo
    url
    currency
    locale
    timezone
    salesTax
    processingFee
    processingFeePercentage
    includeCcFee
    includeConvenienceFee
    includeTaxFee
    address {
      city
      country
      postalCode
      state
      street1
      street2
    }
    rooms {
      id
      name
    }
    logoId
    logo {
      id
      name
      url
    }
    defaultSet {
      ...DefaultSetFields
    }
  }
  ${DEFAULT_SET_FIELDS}
`;
